import { mapGetters } from 'vuex'
import Add from './add.dialog.vue'
import { question } from '../../../../api/questionnaire'

const singleColumns = [
  {
    title: '',
    enTitle: 'Answer',
    width: 400,
    dataIndex: 'answer',
    slot: 'answerInput'
  },
  {
    title: '',
    enTitle: 'Supplementary Q&A',
    width: 400,
    dataIndex: 'supplementary'
  },
  {
    title: '',
    enTitle: '',
    width: 100,
    dataIndex: 'actions',
    slot: 'actions'
  }
]

const multiColumns = [
  {
    title: '',
    enTitle: 'Answer',
    width: 400,
    dataIndex: 'answer',
    slot: 'answerInput'
  },
  {
    title: '',
    enTitle: '',
    width: 100,
    dataIndex: 'actions',
    slot: 'actions'
  }
]

export default {
  components: {
    Add
  },
  data() {
    return {
      params: {
        type: 'SINGLE'
      },
      editId: '',
      isVisable: false,
      columns: singleColumns,
      dataSource: [],
      rules: {},
      questionTypeChoose: [
        {
          label: 'Single Choice',
          value: 'SINGLE'
        },
        {
          label: 'Multiple Choices',
          value: 'MULTIPLE'
        },
        {
          label: 'Answers',
          value: 'QA'
        }
      ]
    }
  },
  computed: {
    ...mapGetters({
      language: 'getLanguage',
      publisherId: 'getPublisherId'
    })
  },
  mounted() {
    this.editId = this.$route.params.id
    this.params.questionnaireId = this.$route.query.questionnaireId
    this.params.sort = 0
    this.getRules()
    this.editId && this.getQuery()
  },
  methods: {
    async getQuery() {
      this.params = await question.query(this.editId)
      if (this.params.type !== 'QA') {
        this.dataSource = JSON.parse(this.params.questionOption)
      }
    },
    async submit() {
      const flag = this.$refs['questionnaire-add-form-first'].validate()
      if (flag) {
        this.params.questionOption = JSON.stringify(this.dataSource)
        this.params.type === 'QA' && delete this.params.questionOption
        this.params.required = true
        const submitData = Object.assign(this.params)
        if (this.editId) {
          await question.edit(this.editId, submitData)
        } else {
          await question.add(submitData)
        }
        this.$message.success({
          title: 'Success',
          content: 'This Question has been saved!'
        })
        this.$router.back(-1)
      }
    },

    handleInputChange(record, index) {
      this.dataSource[index] = record
      this.$set(this.dataSource, index, record)
    },
    addNewAnswer() {
      this.dataSource.push({
        answer: '',
        supplementary: ''
      })
    },
    getRules() {
      this.rules = {
        questionType: [
          {
            required: true,
            message: 'questionType' + this.LANGUAGE[this.language].noEmpty
          }
        ],
        question: [
          {
            required: true,
            message: 'question' + this.LANGUAGE[this.language].noEmpty
          }
        ]
      }
    },
    onInputRadioGroup(val) {
      this.columns = val === 'MULTIPLE' ? multiColumns : singleColumns
    },
    setSort(val) {
      this.dataSource = val
    },

    del(index) {
      this.$confirm({
        title: 'Are you sure you want to delete this key relationship?',
        content:
          'Please be aware of once this key relationship is deleted, it will never be able to recovered.',
        type: 'danger',
        icon: 'iconDelete'
      }).then(async () => {
        this.dataSource.splice(index, 1)
      })
    },

    edit(val, index) {
      const copyVal = JSON.parse(JSON.stringify(val))
      this.$refs['manage-questionnaire-add'].getQuery(copyVal, index)
      this.isVisable = true
    },
    confirm(val, index) {
      this.dataSource[index] = val
      this.$set(this.dataSource, index, val)
      this.isVisable = false
    },
    cancel() {
      this.isVisable = false
    }
  }
}
